import React, { useState } from "react";
import * as XLSX from "xlsx";

const TOKEN = "377045a9fb7193f65bbc7b747a903720b3f3ed763f1ae9bfe308f08430a0db35";

export default function ExcelQRGenerator() {
  const [registros, setRegistros] = useState([]);
  const [cargando, setCargando] = useState(false);

  const leerExcel = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = (evt) => {
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: "binary" });
      const sheet = wb.Sheets[wb.SheetNames[0]];
      const datos = XLSX.utils.sheet_to_json(sheet);

      const usuarios = datos.map((fila) => {
        const nombre = fila["N"]?.trim();
        const url = fila["URL SMART-CONNECT"]?.trim();

        return {
          nombre: nombre || null,
          url: url || null,
          qrUrl: null,
          error: null,
        };
      });

      setRegistros(usuarios);
    };
    reader.readAsBinaryString(file);
  };

  const generarQrMeQr = async (nombre, url) => {
    const payload = {
      qrFieldsData: { link: url },
      title: `SmartConnect_${nombre}`,
      format: "png",
      qrOptions: {
        size: 300,
        errorCorrectionLevel: "Q",
        pattern: "square",
        patternColor: "#000000",
        patternBackground: "#ffffff",
        cornetsOuter: "square",
        cornetsOuterColor: "#000000",
        cornetsInterior: "square",
        cornetsInteriorColor: "#000000",
        logotype:
          "https://firebasestorage.googleapis.com/v0/b/laofi-f175b.appspot.com/o/fotosPerfiles%2F51c578d3-177e-48c5-a712-ddbcd5863df4_Logo.png?alt=media&token=99ea3796-00ca-4021-81a8-8fb51207db27",
        logotypeSize: 0.4,
        logotypeMargin: 0.5,
        logotypeHideBackground: true,
      },
      qrFrame: {
        name: "noFrame",
        color: "#000000",
        backgroundColor: "#ffffff",
        text: "",
        textSize: null,
        textColor: "#9C3AAF",
        textFont: "Roboto",
      },
    };

    const response = await fetch("https://me-qr.com/api/v2/qr/link/create", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-AUTH-TOKEN": TOKEN,
      },
      body: JSON.stringify(payload),
    });

    if (!response.ok) {
      throw new Error(`Error ${response.status}`);
    }

    const blob = await response.blob();
    return URL.createObjectURL(blob);
  };

  const generarTodosQR = async () => {
    setCargando(true);
    const nuevos = [];

    for (let i = 0; i < registros.length; i++) {
      const { nombre, url } = registros[i];

      if (!nombre || !url) {
        nuevos.push({ ...registros[i], error: "Datos incompletos" });
        continue;
      }

      try {
        const qrUrl = await generarQrMeQr(nombre, url);
        nuevos.push({ ...registros[i], qrUrl });
      } catch (err) {
        nuevos.push({ ...registros[i], error: err.message });
      }
    }

    setRegistros(nuevos);
    setCargando(false);
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Generador de QRs desde Excel con ME-QR</h2>
      <input type="file" accept=".xlsx, .xls" onChange={leerExcel} />
      <br />
      <button onClick={generarTodosQR} disabled={cargando || registros.length === 0}>
        {cargando ? "Generando QRs..." : "Generar QRs"}
      </button>

      <div style={{ marginTop: 20 }}>
        {registros.map((r, i) => (
          <div key={i} style={{ border: "1px solid #ccc", padding: 10, marginBottom: 10 }}>
            <strong>{r.nombre || "Nombre no encontrado"}</strong>
            <br />
            <a href={r.url} target="_blank" rel="noopener noreferrer">
              {r.url || "URL faltante"}
            </a>
            <br />
            {r.qrUrl && <img src={r.qrUrl} alt={`QR ${r.nombre}`} width={150} />}
            {r.error && <span style={{ color: "red" }}>{r.error}</span>}
          </div>
        ))}
      </div>
    </div>
  );
}
